<template>
  <div>
    <md-toolbar md-elevation="0" class="md-transparent navbar-top">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <h3 class="md-title">{{ localUser }}</h3>
        </div>
        <div class="md-toolbar-section-end">
          <div class="md-collapse">
            <button type="button" class="btn btn-primary" size="sm" @click="showModal">
              <b-icon
                font-scale="1"
                icon="calendar2-week-fill"
                style="width: 30px; height: 20px"
              ></b-icon>
            </button>
            <div class="til-div">
              <div
                class="uz-style"
                @click="tilClick('uz')"
                :class="{ activeTil: $i18n.locale == 'uz' }"
              >
                uz
              </div>
              <div
                @click="tilClick('ru')"
                class="ru-style"
                :class="{ activeTil: $i18n.locale == 'ru' }"
              >
                ru
              </div>
            </div>
            <md-list>
              <md-list-item href="" @click="logout">
                <b-icon
                  font-scale="1.5"
                  icon="box-arrow-right"
                  style="width: 50px;"
                ></b-icon>
                <!-- <i class="material-icons">logout</i> -->
                <!-- <p class="hidden-lg hidden-md">Profile</p> -->
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>
  
    <b-modal :id="'modal-tekshiruvlar'" title="Бугунги туғилган кунлар" size="xl" hide-footer>
      <b-table
        class="tableStyle"
        id="room-table"
        ref="refUserTable"
        hover
        striped
        primary-key="id"
        :items="items"
        :fields="fields"
        :filter-included-fields="filterOn"
        stacked="md"
        show-empty
        medium
      ></b-table>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  beforeCreate() {
    if (!localStorage.getItem("token")) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      localUser: JSON.parse(localStorage.getItem("user")).user_name,
      items: [],
      fields: [
        { key: "fullname", label: "Бемор ФИО" },
        { key: "birthday", label: "Туғилган куни" },
        { key: "phone", label: "Телефон рақами" }
      ],
      translatedFields: [],
      vaqt: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: ["name"]
    };
  },
  methods: {
    showModal() {
      this.$bvModal.show('modal-tekshiruvlar');
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    logout() {
      localStorage.removeItem("token");
      this.$router.push("/login");
    },
    tilClick(key) {
      this.$i18n.locale = key; // Switch to French locale
      // this.$store.state.locale = key
    },
    data() {
      let s = this;
      axios({
        method: "get",
        url: "/patient/get_all_birthday"
      }).then(res => {
        if (!res.error) {
          for (let key of res.data.data) {
            key.birthday = moment(new Date(key.birthday * 1000)).format(
              "DD.MM.YYYY"
            );
          }
          s.items = res.data.data;
          // s.totalRows = s.items.length;
        }
      });
    },
  },
  mounted() {
    this.data();
  }
};
</script>

<style lang="css" scope>
.navbar-top {
  margin-bottom: 0px;
  height: 25px;
}
.activeTil {
  background: #6f73ff;
  color: #fff;
}
.til-div {
  padding: 5px;
  display: flex;
  font-size: 20px;
  font-weight: 600;
}
.uz-style {
  cursor: pointer;
  border-radius: 10px;
  padding: 2px 7px;
}
.ru-style {
  padding: 2px 7px;
  border-radius: 10px;
  cursor: pointer;
}
.uz-style:hover {
  color: blue !important;
}
.ru-style:hover {
  color: blue !important;
}
.md-collapse {
  display: flex;
  align-items: center;
  gap: 10px;
}
.btn{
  height: 40px;
  margin-right: 10px;
}
</style>
